<div *ngIf="exist; else attente"></div>
<div fxLayout="row">
  <div class="button-row">
    <button
      type="button"
      matTooltip="Crée dossier"
      [disabled]="buttonDisabled"
      class="bet_time"
      mat-button
      color="primary"
      (click)="crerDossier()"
    >
      <mat-icon>create_new_folder</mat-icon>
      <div>Nouveau</div>
    </button>
  </div>
  <div class="button-row">
    <button
      type="button"
      matTooltip="Renommer"
      [disabled]="buttonDisabled"
      class="bet_time"
      mat-button
      color="primary"
      (click)="renommer()"
    >
      <mat-icon> border_color</mat-icon>
      <div>Renommer</div>
    </button>
  </div>
  <div class="button-row">
    <button
      type="button"
      matTooltip="Modèle"
      [disabled]="buttonDisabled"
      class="bet_time"
      mat-button
      color="primary"
      (click)="addModele()"
    >
      <mat-icon>bookmark</mat-icon>
      <div>Modèle</div>
    </button>
  </div>
  <div class="button-row">
    <button
      type="button"
      matTooltip="Supprimer"
      [disabled]="buttonDisabled"
      class="bet_time"
      mat-button
      color="primary"
      (click)="supprimer()"
    >
      <mat-icon>delete</mat-icon>
      <div>Supprimer</div>
    </button>
  </div>
  <div class="button-row">
    <button
      type="button"
      matTooltip="Supprimer modèle"
      [disabled]="buttonDisabled"
      class="bet_time"
      mat-button
      color="primary"
      (click)="supprimerModel()"
    >
      <mat-icon>delete</mat-icon>
      <div>Supprimer modèle</div>
    </button>
  </div>
</div>
<div id="documentColl" class="demo"></div>

<div class="width-input" style="width: 100%">
  <mat-form-field appearance="outline">
    <mat-label>Français</mat-label>
    <input [(ngModel)]="txtFrancais" name="txt1" matInput />
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Anglais</mat-label>
    <input matInput name="txt2" [(ngModel)]="txtAnglais" />
  </mat-form-field>

  <button
    type="button"
    (click)="enregistrerLangue()"
    mat-raised-button
    class="colorGreen"
  >
    Enregistrer
  </button>
</div>
<input id="fileToUpload" type="file" style="display: none" />
<ng-template #attente>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-template>
